module.exports = require("scratch-parser");